import {VehicleFinancingTerm} from '@dms/api/sales';

export const RATE_MATRIX_TERMS: VehicleFinancingTerm[] = [
  12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96,
];
